import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { EnvironmentService } from './environment.service';
import { Observable, map } from 'rxjs';
import { AuditLogResponse, AuditLog } from '../models/Audit/audit';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  apiEndPoint!: string;
  constructor(
    private readonly env: EnvironmentService,
    private readonly http: HttpClient
  ) {
    this.apiEndPoint = this.env.getApiEndpoint();
  }

  getAuditLogs(params: any = {}): Observable<AuditLogResponse> {
    const options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<AuditLogResponse>(this.apiEndPoint + 'report/audit', options);
  }

  getSystemUserLogs(params: any = {}): Observable<AuditLogResponse> {
    const options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<AuditLogResponse>(this.apiEndPoint + 'report/audit', options);
  }

  getLastLogin(params: any = {}): Observable<any> {
    const options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<any>(this.apiEndPoint + 'audit/getLastLogin', options);
  }

  getAllModules(params: any = {}): Observable<any> {
    const options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<any>(this.apiEndPoint + 'audit/overallmodule/list', options)
  }

  exportExcel(params: any = {}): Observable<HttpResponse<Blob>> {
    const options = {
      params: new HttpParams({ fromObject: params }),
      responseType: 'blob' as const,
      observe: 'response' as const,
    };
    return this.http.get(this.apiEndPoint + 'audit/export/excel', options);
  }

  exportPdf(params: any = {}): Observable<HttpResponse<Blob>> {
    const options = {
      params: new HttpParams({ fromObject: params }),
      responseType: 'blob' as const,
      observe: 'response' as const,
    };
    return this.http.get(this.apiEndPoint + 'audit/export/pdf', options);
  }
}
